export default __webpack_public_path__ + "img/9a4cec177405b0cf5132921e671b78b1.svg";